<div class="c-chip__content">
    <ng-content></ng-content>
</div>

<button
    ihdIconButton
    icon="close"
    class="x-chip__icon-btn"
    (click)="close($event)"
>
    <ihd-tooltip>{{ 'Common.Remove' | translate }}</ihd-tooltip>
</button>
